import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, connect } from 'react-redux';
import { Divider, Modal, Loader, Button } from 'rsuite';
import * as actionsUser  from '../../../../../app/actions/user';
import {addExistingPolicy}  from '../../../../../app/common/services/fetch.service';
import {BackIcon} from '../../svg/iconsSvg';
import AddPolicyCarousel from './AddPolicyCarousel';
import { NuInsInputTextLabel } from '../../elements/inputFieldsLabel';
import { CheckBoxCustom } from '../../elements/inputFields';
import { InfoIcon } from '../../svg/iconsSvg';


const AddPolicyMain = ({onForward, onBack, getMyPolicies}) => {

    const history = useHistory();

    const auth = useSelector(state => state.auth);

    const [errorModal, setErrorModal] = useState({show: false, msg: 'Въведеният регистрационен номер и/или номер на полица е грешен. Провери въведените данни'});
    
    const [plate, setPlate] = useState(null);
    const [policy, setPolicy] = useState(null);
    const [acceptedCondition, setAcceptedCondition] = useState(null);

    const [showCondition, setShowCondition] = useState(false);
    const [showConfidentiality, setShowConfidentiality] = useState(false);

    const [loading, setLoading] = useState(false);

    const goBack = () => onBack(1);

    const onConfirmError = () => setErrorModal({show: false, msg: 'Въведеният регистрационен номер и/или номер на полица е грешен. Провери въведените данни'});

    const onCancel = () => onForward(1);

    const goToLogin = () => history.push('/app/profile');

    const goToSignUp = () => history.push('/app/sign-up');
        
    const validateFields = () => {
        return plate && policy && acceptedCondition;
    }

    const submitHandler = async () => {
        if(!validateFields()) return;

        setLoading(true)

        let res;

        try{
            res = await addExistingPolicy(plate, policy);
        } catch(error) {
            console.log(error);
            setLoading(false);
        }

        if(res && res.data?.success) {
            getMyPolicies();
            onForward(3, null, plate, policy);
        } else {
            if(res.data?.messageCode && res.data?.messageCode === 'POLICY_ALREADY_EXISTS_IN_THE_SYSTEM') {
                setErrorModal({ show: true, msg: 'Тази полица е въведена в системата за друг потребител'});
                return setLoading(false);
            }
            setErrorModal({...errorModal, show: true});
            setLoading(false);
        }
    }

    return (
        <div className="steps_container" >
            <div  className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>ГРАЖДАНСКА ОТГОВОРНОСТ</h6>
            </div>
            <Divider />
            <h6 style={{alignSelf: 'center', margin: '1rem 0'}} >ДОБАВЯНЕ НА ПОЛИЦА ЗА НАПОМНЯНЕ</h6>
            <AddPolicyCarousel />
   
            <NuInsInputTextLabel validationType={"plate"} onChange={data => setPlate(data)} 
                        placeholder={"Регистрационен номер на МПС"} value={plate}
                        styles={{marginBottom: '20px', marginTop: '20px'}}/>
       
            <NuInsInputTextLabel onChange={data => setPolicy(data)} placeholder={"Номер на съществуваща полица"} 
                                 value={policy} styles={{marginBottom: '20px'}}/> 
         
            <div className="steps_container-checkbox">
                <CheckBoxCustom onChange={data => setAcceptedCondition(data)} value={acceptedCondition}/>
                <div>Приемам <span className="link-pdf" onClick={()=>setShowCondition(true)}>Общите условия</span> на услугата и се запознах с <span onClick={()=>setShowConfidentiality(true)} className="link-pdf">Уведомлението за поверителност Информация за потребителя по чл. 325 от КЗ</span></div>
            </div>
            <Divider />
            <div className="steps_container-checkbox">
                <InfoIcon size="38" style={{marginLeft: '2px'}}/>
                <div>Регистриран застрахователен брокер с удостоверение № 801-ЗБ от 31.01.2022 г., издадено от КФН</div>
            </div>
            <Divider />
 
            <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-main" type="submit" disabled={!validateFields()} onClick={submitHandler}>Добави полица</button>
              
            {loading ? <Loader backdrop center size="lg"  speed="slow" /> : null}

            <Modal size="sm" show={showCondition || showConfidentiality} onHide={() => {setShowCondition(false); setShowConfidentiality(false);}}>
                <Modal.Header> </Modal.Header>
                <Modal.Body>
                    <iframe src={showCondition ?  "/files/Obshti-usloviya.pdf" : "/files/Uvedomlenie-za-poveritelnost.pdf"}  
                            style={{width:"550px", minHeight:"95vh"}} title="showCondition"/>
                </Modal.Body>
            </Modal>

            <Modal size="xs" className="nuins-ok-modal" show={errorModal.show} onHide={() => onConfirmError()}>
                <Modal.Body>
                    <p className="no-reg-data">{errorModal.msg}</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onConfirmError()} >OK</Button>
                </Modal.Footer>
            </Modal>

            <Modal size="xs" className="nuins-cancel-modal" show={!auth?.loginToken} onHide={() => onCancel()}>
                <Modal.Body>
                    <p className="no-reg-data">За да добавите нова полица, трябва да влезете в профила си</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onCancel()} >Cancel</Button>
                    <Button onClick={() => goToSignUp()} >Създай профил</Button>
                    <Button onClick={() => goToLogin()} active>Влез в профил</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default connect(null, actionsUser)(AddPolicyMain);

